import React from 'react'

export default function NotFound() {
    return (
        <div className="container mt-3">
            <h1>Oops!</h1>
            <p>The page you're looking for can't be found.</p>
        </div>
    )
}
